import httpRequest from "services/httpRequest";

const prefix = "/api/message";

export const getPageMessage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: params,
  });
  if (result) {
    return result;
  }
  return {};
};

export const sendMessage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: params,
  });
  return result;
};

export const onUpdateMessage = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params,
    // successMessage: "toast.update_success",
  });
  return result;
};

export const onReadMessage = async params => {
  const result = await httpRequest({
    url: `${prefix}/read/conversation/${params.id}`,
    method: "PUT",
    data: params,
    // successMessage: "toast.update_success",
  });
  return result;
};

export const onGetMessageReview = async params => {
  const result = await httpRequest({
    url: `${prefix}/in-review`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetMessagePast = async params => {
  const result = await httpRequest({
    url: `${prefix}/broadcast`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetMessageFeature = async params => {
  const result = await httpRequest({
    url: `${prefix}/broadcast`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetMessageDetail = async params => {
  const result = await httpRequest({
    url: `/api/message/${params}`,
    method: "GET",
  });
  return result;
};

export const onGetMessageInReviewDetail = async params => {
  const result = await httpRequest({
    url: `/api/message/${params}`,
    method: "GET",
  });
  return result;
};

export const onGetRecipientsDetailPage = async params => {
  const result = await httpRequest({
    url: `/api/broadcast/recipients`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetRecipientsFutureDetail = async params => {
  const result = await httpRequest({
    url: `/api/broadcast/future`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onDeleteMessage = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
  return result;
};

export const onUpdateStatusMessage = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params.data,
    successMessage: "toast.update_success",
  });
  return result;
};

export const onHideMessageSpam = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params.data,
    successMessage: "toast.hide_message_success",
  });
  return result;
};
export const onUpdateMessageDetail = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params.data,
    successMessage: "toast.update_success",
  });
  return result;
};

export const onGetBroadcastDetail = async params => {
  const result = await httpRequest({
    url: `/api/broadcast/${params.id}`,
    method: "GET",
  });
  return result;
};

export const onUpdateBroadcast = async params => {
  const result = await httpRequest({
    url: `/api/broadcast/${params.id}`,
    method: "PUT",
    data: params.data,
    successMessage: "toast.update_success",
  });
  return result;
};

export const onDeleteBroadcast = async params => {
  const result = await httpRequest({
    url: `/api/broadcast/${params.id}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
  return result;
};

export const onExportRecipients = async params => {
  const result = await httpRequest({
    url: `/api/broadcast/export-recipients`,
    method: "GET",
    params: params,
  });
  return result;
};
